<template>
  <NuxtLayout name="default">
    <v-container>
      <v-row>
        <v-col
          cols="12"
          md="3"
        >
          <v-list>
            <template v-for="(header, i) in headers" :key="i">
              <v-list-subheader :class="{ 'mt-4': i > 0 }">{{ header.title }}</v-list-subheader>
              <v-list-item
                v-for="(item, j) in header.items"
                :key="`${i}-${j}`"
                nuxt
                :to="item.to"
                :title="item.title"
              >
              </v-list-item>
            </template>
          </v-list>
        </v-col>
        <v-col>
          <Breadcrumbs v-if="breadcrumbItems.length > 1" :items="breadcrumbItems" class="mb-2" />
          <slot />
        </v-col>
      </v-row>
    </v-container>
  </NuxtLayout>
</template>

<script lang="ts">
export default {
  data () {
    return {
      headers: [
        {
          title: 'For Sailors',
          items: [
            { title: 'Overview', to: { name: 'documentation-sailors___en' } },
            { title: 'Tracking with the App', to: { name: 'documentation-sailors-tracking___en' } },
            { title: 'Uploading Sessions', to: { name: 'documentation-sailors-uploading___en' } },
            { title: 'The Analysis View', to: { name: 'documentation-sailors-analysis-view___en' } },
            { title: 'Multi-Boat Analysis View', to: { name: 'documentation-sailors-course-analysis___en' } },
            { title: 'Live Metrics', to: { name: 'documentation-sailors-live-metrics___en' } },
            { title: 'Training Mode', to: { name: 'documentation-sailors-training-mode___en' } },
            { title: 'Movement & Vision Analysis', to: { name: 'documentation-sailors-movement-vision-analysis___en' } }
          ]
        },
        {
          title: 'For Coaches',
          items: [
            { title: 'Overview', to: { name: 'documentation-coaches___en' } },
            { title: 'Student Progress', to: { name: 'documentation-coaches-student-progress___en' } }
          ]
        },
        {
          title: 'For Regatta Organizers',
          items: [
            { title: 'Overview', to: { name: 'documentation-competitions___en' } },
            { title: 'Create a competition', to: { name: 'documentation-competitions-create___en' } },
            { title: 'Time tracking app', to: { name: 'documentation-competitions-time-tracking-app___en' } },
            { title: 'Live GPS Tracking & Streaming', to: { name: 'documentation-competitions-live-mode___en' } },
            { title: 'Finish Line Video Processing', to: { name: 'documentation-competitions-finish-line-video-processing___en' } }
          ]
        },
      ]
    }
  },
  computed: {
    // Documentation / For X / Page title, built from the same `headers` data the sidebar
    // nav uses -- so a page only needs adding to `headers` once for both nav and breadcrumbs.
    breadcrumbItems () {
      const routeName = this.$route.name
      const items = [{ title: 'Documentation', href: '/documentation', disabled: routeName === 'documentation___en' }]
      if (routeName === 'documentation___en') return items

      const section = this.headers.find((h) =>
        h.items.some((item) => routeName?.toString().startsWith(item.to.name.replace('___en', '')))
      )
      if (!section) return items

      const overview = section.items[0]
      items.push({
        title: section.title,
        href: this.$router.resolve({ name: overview.to.name }).path,
        disabled: routeName === overview.to.name,
      })
      if (routeName === overview.to.name) return items

      const page = section.items.find((item) => item.to.name === routeName)
      if (page) {
        items.push({ title: page.title, href: this.$route.path, disabled: true })
      }
      return items
    },
  },
}
</script>
